import { useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle, Send } from "lucide-react";
import { PHONE_MAIN } from "@/lib/contact";

export default function WhatsAppWidget() {
  const [car, setCar] = useState("");
  const [part, setPart] = useState("");
  const [vin, setVin] = useState("");
  const [name, setName] = useState("");

  const ready = car.trim() && part.trim();

  const send = () => {
    if (!ready) return;
    const msg = `Bună ziua! ${name.trim() ? `Sunt ${name.trim()}. ` : ""}Am o mașină ${car.trim()}${vin.trim() ? ` (serie de șasiu: ${vin.trim()})` : ""} și aș dori o ofertă pentru: ${part.trim()}.`;
    window.open(`https://wa.me/40786804728?text=${encodeURIComponent(msg)}`, "_blank", "noopener,noreferrer");
  };

  const inputCls =
    "w-full bg-[#07122B] border border-white/15 focus:border-[#0055FF] outline-none px-4 py-3.5 text-sm text-white placeholder:text-slate-600 transition-colors";

  return (
    <section id="whatsapp" data-testid="whatsapp-section" className="relative py-20 lg:py-28 overflow-hidden">
      <div className="absolute -top-24 left-1/3 h-[380px] w-[380px] rounded-full bg-[#0055FF]/10 blur-[130px]" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-6"
        >
          <div className="flex items-center gap-3 mb-4">
            <MessageCircle className="h-5 w-5 text-[#0055FF]" />
            <span className="text-xs font-mono uppercase tracking-[0.28em] text-slate-500">Cerere piesă pe WhatsApp</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight leading-tight">
            Spune-ne piesa, <span className="text-[#0055FF]">îți răspundem pe</span> <span className="text-[#FF2A3B]">WhatsApp</span>
          </h2>
          <p className="mt-4 max-w-lg text-sm sm:text-base text-slate-400 leading-relaxed">
            Scrie modelul mașinii și piesa de care ai nevoie — mesajul se trimite direct pe
            WhatsApp-ul magazinului, la <span className="text-white">{PHONE_MAIN}</span>. Dacă lași și seria de șasiu (VIN),
            îți verificăm compatibilitatea exactă. Iar piesele care nu sunt pe stoc le aducem{" "}
            <span className="text-white">pe comandă</span>.
          </p>

          <div className="mt-8 grid gap-4 max-w-lg">
            <input
              data-testid="wa-car-input"
              value={car}
              onChange={(e) => setCar(e.target.value)}
              placeholder="Modelul mașinii * (ex: Dacia Logan 2018, 1.5 dCi)"
              className={inputCls}
            />
            <input
              data-testid="wa-part-input"
              value={part}
              onChange={(e) => setPart(e.target.value)}
              placeholder="Piesa dorită * (ex: set plăcuțe frână față)"
              className={inputCls}
            />
            <input
              data-testid="wa-vin-input"
              value={vin}
              onChange={(e) => setVin(e.target.value)}
              placeholder="Serie de șasiu / VIN (opțional — pentru potrivire exactă)"
              className={inputCls}
            />
            <input
              data-testid="wa-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Numele tău (opțional)"
              className={inputCls}
            />
            <motion.button
              data-testid="wa-send-button"
              whileTap={{ scale: 0.98 }}
              onClick={send}
              disabled={!ready}
              className="flex items-center justify-center gap-2 bg-[#0055FF] hover:bg-[#FF2A3B] disabled:opacity-40 disabled:cursor-not-allowed py-4 font-display font-bold uppercase tracking-wide text-sm text-white transition-colors duration-300"
            >
              <Send className="h-4 w-4" />
              Trimite cererea pe WhatsApp
            </motion.button>
            <p className="text-[11px] text-slate-600">Se deschide WhatsApp cu mesajul pregătit — apeși doar trimite.</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ clipPath: "inset(0 0 100% 0)" }}
          whileInView={{ clipPath: "inset(0 0 0% 0)" }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-6 relative"
        >
          <div className="relative overflow-hidden border border-white/10 bg-white">
            <img
              data-testid="wa-parts-image"
              src="/images/img6.jpg"
              alt="Piese auto aranjate în forma unei mașini"
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -top-3 -left-3 h-16 w-16 border-t-2 border-l-2 border-[#0055FF]" />
          <div className="absolute -bottom-3 -right-3 h-16 w-16 border-b-2 border-r-2 border-[#FF2A3B]" />
        </motion.div>
      </div>
    </section>
  );
}
